import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import dayjsTZPlugin from 'dayjs/plugin/timezone';
import dayjsUTCPlugin from 'dayjs/plugin/utc';

dayjs.extend(dayjsUTCPlugin);
dayjs.extend(dayjsTZPlugin);
dayjs.extend(isSameOrBefore);
dayjs.locale('ja');

const TOKYO_TIMEZONE = 'Asia/Tokyo';

/**
 * Return dayjs with tokyo timezone
 * @param date dayjs.ConfigType
 * @returns dayjs.Dayjs
 */
export function dayJST(date?: dayjs.ConfigType) {
  return dayjs(date).tz(TOKYO_TIMEZONE);
}
